"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDrillableSeries = void 0;
var tslib_1 = require("tslib");
var common_1 = require("../_util/common");
var omit_1 = tslib_1.__importDefault(require("lodash/omit"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var chartCapabilities_1 = require("./chartCapabilities");
var executionResultHelper_1 = require("../_util/executionResultHelper");
var without_1 = tslib_1.__importDefault(require("lodash/without"));
function getViewBy(viewByAttribute, viewByIndex) {
    var viewByHeader = null;
    var viewByItem = null;
    var viewByAttributeDescriptor = null;
    if (viewByAttribute) {
        viewByHeader = viewByAttribute.items[viewByIndex];
        viewByItem = tslib_1.__assign(tslib_1.__assign({}, common_1.unwrap(viewByHeader)), { attribute: viewByAttribute });
        viewByAttributeDescriptor = { attributeHeader: omit_1.default(viewByAttribute, "items") };
    }
    return {
        viewByHeader: viewByHeader,
        viewByItem: viewByItem,
        viewByAttributeDescriptor: viewByAttributeDescriptor,
    };
}
function getStackBy(stackByAttribute, stackByIndex) {
    var stackByHeader = null;
    var stackByItem = null;
    var stackByAttributeDescriptor = null;
    if (stackByAttribute) {
        // stackBy item index is always equal to seriesIndex
        stackByHeader = stackByAttribute.items[stackByIndex];
        stackByItem = tslib_1.__assign(tslib_1.__assign({}, common_1.unwrap(stackByHeader)), { attribute: stackByAttribute });
        stackByAttributeDescriptor = { attributeHeader: omit_1.default(stackByAttribute, "items") };
    }
    return {
        stackByHeader: stackByHeader,
        stackByItem: stackByItem,
        stackByAttributeDescriptor: stackByAttributeDescriptor,
    };
}
function getDrillableSeries(dv, series, drillableItems, viewByAttributes, stackByAttribute, type) {
    var viewByChildAttribute = viewByAttributes[0], viewByParentAttribute = viewByAttributes[1];
    var isMultiMeasureWithOnlyMeasures = common_1.isOneOfTypes(type, chartCapabilities_1.multiMeasuresAlternatingTypes) && !viewByChildAttribute;
    var measureGroup = executionResultHelper_1.findMeasureGroupInDimensions(dv.meta().dimensions());
    return series.map(function (seriesItem) {
        var seriesIndex = seriesItem.seriesIndex;
        var isSeriesDrillable = false;
        var data = seriesItem.data &&
            seriesItem.data.map(function (pointData, pointIndex) {
                var _a, _b;
                var measureHeaders = [];
                var isStackedTreemap = common_1.isTreemap(type) && !!stackByAttribute;
                if (common_1.isScatterPlot(type)) {
                    measureHeaders = ((_a = measureGroup.items) !== null && _a !== void 0 ? _a : []).slice(0, 2);
                }
                else if (common_1.isBubbleChart(type)) {
                    measureHeaders = ((_b = measureGroup.items) !== null && _b !== void 0 ? _b : []).slice(0, 3);
                }
                else if (isStackedTreemap) {
                    if (pointData.id !== undefined) {
                        // not leaf -> can't be drillable
                        return pointData;
                    }
                    var measureIndex = viewByChildAttribute ? 0 : parseInt(pointData.parent, 10);
                    measureHeaders = [measureGroup.items[measureIndex]];
                }
                else {
                    // measureIndex is usually seriesIndex,
                    // except for stack by attribute and metricOnly pie or donut chart
                    // it is looped-around pointIndex instead
                    // Looping around the end of items array only works when
                    // measureGroup is the last header on it's dimension
                    // We do not support setups with measureGroup before attributeHeaders
                    var measureIndex = !stackByAttribute && !isMultiMeasureWithOnlyMeasures
                        ? seriesIndex
                        : pointIndex % measureGroup.items.length;
                    measureHeaders = [measureGroup.items[measureIndex]];
                }
                var viewByIndex = common_1.isHeatmap(type) || isStackedTreemap ? pointData.x : pointIndex;
                var stackByIndex = common_1.isHeatmap(type) || isStackedTreemap ? pointData.y : seriesIndex;
                if (common_1.isScatterPlot(type)) {
                    stackByIndex = viewByIndex; // scatter plot uses stack by attribute but has only one serie
                }
                var _c = getStackBy(stackByAttribute, stackByIndex), stackByHeader = _c.stackByHeader, stackByAttributeDescriptor = _c.stackByAttributeDescriptor;
                var _d = getViewBy(viewByChildAttribute, viewByIndex), viewByChildHeader = _d.viewByHeader, viewByChildAttributeDescriptor = _d.viewByAttributeDescriptor;
                var _e = getViewBy(viewByParentAttribute, viewByIndex), viewByParentHeader = _e.viewByHeader, viewByParentdAttributeDescriptor = _e.viewByAttributeDescriptor;
                // point is drillable if a drillableItem matches:
                //   point's measure,
                //   point's viewBy attribute,
                //   point's viewBy attribute item,
                //   point's stackBy attribute,
                //   point's stackBy attribute item,
                var drillableHooks = without_1.default(tslib_1.__spreadArrays(measureHeaders, [
                    viewByChildAttributeDescriptor,
                    viewByChildHeader,
                    viewByParentdAttributeDescriptor,
                    viewByParentHeader,
                    stackByAttributeDescriptor,
                    stackByHeader,
                ]), null);
                var drilldown = drillableHooks.some(function (drillableHook) {
                    return sdk_ui_1.isSomeHeaderPredicateMatched(drillableItems, drillableHook, dv);
                });
                var drillableProps = {
                    drilldown: drilldown,
                };
                if (drilldown) {
                    var headers = tslib_1.__spreadArrays(measureHeaders, [
                        viewByChildHeader,
                        viewByChildAttributeDescriptor,
                        viewByParentHeader,
                        viewByParentdAttributeDescriptor,
                        stackByHeader,
                        stackByAttributeDescriptor,
                    ]);
                    var sanitizedHeaders = without_1.default(tslib_1.__spreadArrays(headers), null);
                    drillableProps.drillIntersection = sdk_ui_1.getDrillIntersection(sanitizedHeaders);
                    isSeriesDrillable = true;
                }
                return tslib_1.__assign(tslib_1.__assign({}, pointData), drillableProps);
            });
        if (common_1.isScatterPlot(type)) {
            data = data.filter(function (dataItem) {
                return dataItem.x !== null && dataItem.y !== null;
            });
        }
        return tslib_1.__assign(tslib_1.__assign({}, seriesItem), { data: data, isDrillable: isSeriesDrillable });
    });
}
exports.getDrillableSeries = getDrillableSeries;
//# sourceMappingURL=chartDrilling.js.map